const userType = JSON.parse(localStorage.getItem("user"))?.type;

const RouteUrls = {
  auth: {
    login: "/sign-in",
    forgot_password: "/forgot-password",
    change_password: "/change-password",
  },
  commit: "/commit",
  dashboard: userType == 2 ? "/report/chart" : "/",
  domain: {
    add: "/domain/add",
    edit: "/domain/edit",
    list: "/domain/list"
  },
  report: {
    statistic: "/report/statistic",
    chart: "/report/chart"
  },
  site: {
    add: "/site/add",
    list: "/site/list"
  },
  user: {
    add: "/user/add",
    list: "/user/list"
  }
};
export default RouteUrls;